import gql from 'graphql-tag'

export default gql`
	mutation deleteLoyaltyCardGroup($id: ID!) {
		cashAssist {
			deleteLoyaltyCardGroup(id: $id) {
				id
			}
		}
	}
`
